import styled from "styled-components";

export type CardContainerProps = {
  primary?: boolean;
};

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    line-height: 1;
`;

export const CardsPanelTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const CardsPanelTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  margin: 0;
`;

export const CardsPanelSubtitle = styled.p`
  margin: 0;
  color: #595959;
  font-size: 14px;
  font-weight: 400;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
`;

export const CardsPanelContainer = styled.div<CardContainerProps>`
  flex: 1;
  min-width: 280px;
  padding: 16px;
  background-color: ${({ primary }) => (primary ? "#fff9eb" : "#f5f5f5")};
  border: ${({ primary }) => (primary ? "1px solid #ffeac2" : "none")};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CardPanelTitle = styled.h4`
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 4px 0;
  color: #262626;
`;

export const CardPanelSubTitle = styled.p`
  font-size: 12px;
  color: #8c8c8c;
  margin: 0;
`;

export const CardPanelValue = styled.div<{ primary?: boolean }>`
  font-size: ${({ primary }) => (primary ? "20px" : "18px")};
  font-weight: 700;
  color: ${({ primary }) => (primary ? "#f78e1e" : "#000")};
`;
